<div class="atlas-table">
  <p-table [showGridlines]="true"
    [lazy]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="LastName">
          {{ 'committees.edit.committee-meetings.attendance.name' | translate | ucfirst }}
          <p-sortIcon field="LastName"></p-sortIcon>
        </th>
        <th pSortableColumn="Attended" class="t-ac" [style]="{ width: '120px' }">
          {{ 'committees.edit.committee-meetings.attendance.attended' | translate | ucfirst }}
          <p-sortIcon field="Attended"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-attendee>
      <tr>
        <td>
          {{ attendee.FirstName }} {{ attendee.LastName }}
          <ng-container *ngIf="attendee.IsGuest">
            ({{ 'committees.edit.committee-meetings.attendance.guest' | translate | titlecase }})
          </ng-container>
        </td>
        <td class="t-ac">
          <ng-container *ngIf="!attendee.IsGuest; else guestAttendee">
            <p-checkbox [(ngModel)]="attendee.Attended" [binary]="true" (onChange)="attendedChanged(attendee)"></p-checkbox>
          </ng-container>
          <ng-template #guestAttendee>
            <a class="f-wb" (click)="removeGuest(attendee)">{{ 'common.remove' | translate | uppercase }}</a>
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
